(() => {
  const selector = '[data-product-comparison]';
  const instances = new Map();
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const update = (instance) => {
    const motionAllowed = !instance.respectReducedMotion || !reducedMotion.matches;
    const active = instance.visible && !document.hidden && motionAllowed;
    instance.root.classList.toggle('is-effect-active', active);
    instance.root.classList.toggle('is-effect-paused', !active);
  };

  const init = (scope = document) => {
    scope.querySelectorAll(selector).forEach((root) => {
      if (instances.has(root)) return;

      const rect = root.getBoundingClientRect();
      const instance = {
        root,
        visible: rect.bottom >= -160 && rect.top <= window.innerHeight + 160,
        respectReducedMotion: root.dataset.respectReducedMotion !== 'false',
        observer: null
      };
      if ('IntersectionObserver' in window) {
        instance.observer = new IntersectionObserver((entries) => {
          instance.visible = entries.some((entry) => entry.isIntersecting);
          update(instance);
        }, { rootMargin: '160px 0px', threshold: 0 });
        instance.observer.observe(root);
      } else {
        instance.visible = true;
      }

      instances.set(root, instance);
      update(instance);
    });
  };

  const destroy = (scope) => {
    scope.querySelectorAll(selector).forEach((root) => {
      const instance = instances.get(root);
      if (!instance) return;
      instance.observer?.disconnect();
      instances.delete(root);
    });
  };

  const updateAll = () => instances.forEach(update);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }

  document.addEventListener('visibilitychange', updateAll);
  reducedMotion.addEventListener?.('change', updateAll);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => destroy(event.target));
})();
